import React from "react";

export default function LoadingSkeleton() {
  return (
    <div className="space-y-10" data-testid="loading-skeleton">
      {[0, 1].map((g) => (
        <section key={g}>
          <div className="skeleton h-12 mb-6" />
          {[0, 1, 2].map((i) => (
            <div key={i} className="grid grid-cols-12 gap-4 py-5 rule-thin">
              <div className="col-span-2">
                <div className="skeleton h-5 w-20" />
              </div>
              <div className="col-span-7 space-y-2">
                <div className="skeleton h-7 w-3/4" />
                <div className="skeleton h-3 w-1/3" />
              </div>
              <div className="col-span-3 flex justify-end items-start">
                <div className="skeleton h-6 w-24" />
              </div>
            </div>
          ))}
        </section>
      ))}
    </div>
  );
}
